<template>
    <a href="#" @click.stop.prevent="toggle" id="feedback-toggle" title="Feedback">
        <svg
            width="96"
            height="96"
            version="1.1"
            viewBox="0 0 96 96"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
        >
            <g transform="scale(4)">
                <path
                    fill="#FFF"
                    d="M20,2h-16c-1.1,0 -2,0.9 -2,2v18l4,-4h14c1.1,0 2,-0.9 2,-2v-12c0,-1.1 -0.9,-2 -2,-2Z"
                ></path>
                <path fill="none" d="M0,0h24v24h-24Z"></path>
            </g>
        </svg>
    </a>
</template>

<script>
export default {
    mounted() {},
    methods: {
        toggle() {
            if (typeof window.zsLoadAutoSuggestions === 'undefined') {
                return;
            }

            this.fixSupportModal();

            window.zsLoadAutoSuggestions();
        },

        fixSupportModal() {
            const modalTitle = document.getElementById('popupTitle');

            if (!modalTitle) {
                return setTimeout(this.fixSupportModal, 100);
            }

            modalTitle.innerText = 'Broadway Business/Grosses';

            const modalForm = document.getElementById('FeedbackformID');

            if (!document.getElementById('bb-feedback-description')) {
                const p = document.createElement('p');

                p.innerText =
                    ' Please use the form below to submit any feedback or corrections.';

                p.id = 'bb-feedback-description';

                modalForm.prepend(p);
            }

            document.getElementById('feedbPopupSbmtBtn').value =
                'Submit Feedback';
        },
    },
};
</script>

